import { makeStyles } from "@material-ui/core/styles";

export const descendingComparator = (a, b, orderBy) => {
  let valueA = a[orderBy] ?? "";
  let valueB = b[orderBy] ?? "";

  if (orderBy === "isFavorite") {
    return valueB - valueA;
  }

  if (typeof valueA === "boolean") {
    valueA = valueA ? 1 : 0;
  }

  if (typeof valueB === "boolean") {
    valueB = valueB ? 1 : 0;
  }

  if (typeof valueA === "number" && typeof valueB === "number") {
    return valueB - valueA;
  } else if (typeof valueA === "string" && typeof valueB === "string") {
    return valueB.localeCompare(valueA);
  } else {
    throw new Error("Unsupported data type for comparison");
  }
};

export const getComparator = (order, orderBy) => {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
};

export const stableSort = (array, comparator) => {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
};

export const otherStyles = makeStyles((theme) => ({
  link: {
    color: "var(--teal-700) !important",
    cursor: "pointer",
    fontWeight: "normal",
    textDecoration: "underline",
    "&:hover": {
      fontWeight: "bold",
    },
    "&:focus": {
      outline: "1px solid var(--teal-500)",
      outlineOffset: "4px",
    },
    "&:active": {
      color: "var(--White)",
    },
    "&:disabled": {
      opacity: 0.6,
      cursor: "not-allowed",
    },
  },

  iconButton: {
    color: "var(--teal-700)",
    "&:hover": {
      backgroundColor: "var(--teal-100)",
    },
    "&:active": {
      backgroundColor: "var(--teal-300)",
    },
    "&:focus": {
      outline: "1px solid var(--teal-500)",
      outlineOffset: "4px",
    },
    "&:disabled": {
      opacity: 0.6,
    },
  },
}));

export const formatDate = (date) => {
  return new Date(date).toISOString();
};

export const formatInputValue = (value) => {
  const actualValue = value?.target?.value !== undefined ? value.target.value : value;
  let formattedValue;
  if (actualValue === "" || actualValue === null || actualValue === undefined) {
    formattedValue = actualValue;
  } else if (actualValue.startsWith("-") && actualValue.length > 1) {
    formattedValue = null;
  } else {
    formattedValue = isNaN(actualValue) ? actualValue : Number(actualValue);
  }
  return formattedValue;
}